import { useState, useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';

export function useConfirmModal() {
  const [state, setState] = useState({ show: false, message: '', resolve: null });

  const confirm = useCallback((message) => {
    return new Promise((resolve) => {
      setState({ show: true, message, resolve });
    });
  }, []);

  const handleConfirm = () => {
    state.resolve(true);
    setState({ show: false, message: '', resolve: null });
  };

  const handleCancel = () => {
    state.resolve(false);
    setState({ show: false, message: '', resolve: null });
  };

  const ConfirmModalJSX = (
    <Modal show={state.show} onHide={handleCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Action</Modal.Title>
      </Modal.Header>
      <Modal.Body>{state.message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return { confirm, ConfirmModalJSX };
}
